import { getArticleTypeFromMedia } from './getArticleTypeFromMedia'

export function setBatchEvents(callback: () => void): void {
	window.batchInit ? callback() : document.addEventListener('BATCH:init', callback)
}

export function setBatchEventsArticle(): void {
	const articleType = getArticleTypeFromMedia()

	const tagElements = document.querySelectorAll('.article-tags .tagList-listItemLink')
	const keywords: string[] = []
	tagElements.forEach((tag) => {
		const tagText = tag.textContent?.trim()?.toLowerCase()
		if (tagText) {
			keywords.push(tagText)
		}
	})

	window.batchSDK((api) => {
		// @ts-expect-error - trackEvent method may not be properly typed
		api.trackEvent('read_article', {
			attributes: {
				has_diapo: !!document.querySelector('.article-diapo'),
				has_paywall: !!document.querySelector('.articleBody .articleWall'),
				image:
					document.querySelector('meta[property="og:image"]')?.getAttribute('content') ||
					'',
				type: articleType,
				last_article_read_date: new Date().toLocaleDateString('fr'),
				url: window.location.origin + window.location.pathname,
				$tags: keywords
			}
		})
	})
}

export async function setBatchEventsArticleShareButtons(): Promise<void> {
	window.batchSDK(async (api) => {
		const articleType = getArticleTypeFromMedia()

		// @ts-expect-error - trackEvent method may not be properly typed
		api.trackEvent('shared_article', {
			attributes: {
				has_paywall: !!document.querySelector('.articleBody .articleWall'),
				image:
					document.querySelector('meta[property="og:image"]')?.getAttribute('content') ||
					'',
				type: articleType,
				url: window.location.origin + window.location.pathname
			}
		})

		const profile = await api.profile()

		// @ts-expect-error - trackEvent method may not be properly typed
		await profile.edit((editor) => {
			editor.setAttribute('shared_article', true)
			editor.setAttribute('last_article_shared_date', new Date().toLocaleDateString('fr'))
		})
	})
}

export async function setBatchEventsArticleWall(
	isUserSubscribed: boolean,
	subscription: string[]
): Promise<void> {
	window.batchSDK(async (api) => {
		const profile = await api.profile()
		// @ts-expect-error - trackEvent method may not be properly typed
		await profile.edit((editor) => {
			editor.setAttribute('has_subscription', isUserSubscribed)
			editor.setAttribute('subscription_type', subscription)
		})
	})
}
